import { useEffect, useRef } from 'react';

export const useNavGoTop = () => {
    const top = useRef<number>(0);
    const handleGoTop = () => {
        const nav = document.querySelector('#global-nav-product') as HTMLDivElement;

        const { top } = nav.getBoundingClientRect();
        if (top === 0) {
            const head = document.querySelector('.ecoflow-frame-header') as HTMLDivElement;
            const pkHead = document.querySelector('#head-device-container') as HTMLDivElement;
            const heght = head.offsetHeight + pkHead.offsetHeight;
            window.scrollTo({
                top: heght,
                behavior: 'smooth',
            });
        } else {
            nav.scrollIntoView({
                behavior: 'smooth',
            });
        }

        // // 切换时划回顶部
        // setTimeout(() => {
        //     window.scrollTo({
        //         top: top.current,
        //         behavior: 'smooth',
        //     });
        // }, 100);
    };
    useEffect(() => {
        const nav = document.querySelector('#global-nav-product') as HTMLDivElement;
        top.current = nav.getBoundingClientRect().top;
    }, []);
    return {
        handleGoTop,
    };
};
